export const GET_TRIP_REPORTS = 'GET_TRIP_REPORTS';
export const GET_TRIP_HISTORICAL = 'GET_TRIP_HISTORICAL';
